import { createFileRoute } from "@tanstack/react-router";
import MainTrackPage from "@/components/audiolab/MainTrackPage";
import {
  tracksControllerTrackDetail,
  getTracksControllerTrackDetailQueryKey,
} from "@/lib/lutely-api/gen/tracks/tracks";
import { queryClient } from "@/components/providers";
import type { DetailTrackDto } from "@/lib/lutely-api/gen/dtos";
import { breadcrumbJsonLd, creatorPath, seoHead } from "@/lib/seo";
import { trackJsonLd } from "@/lib/seo-music";

export const Route = createFileRoute("/tracks/$TRACK_ID")({
  loader: async ({ params }) => {
    try {
      const track = await queryClient.fetchQuery({
        queryKey: getTracksControllerTrackDetailQueryKey(params.TRACK_ID),
        queryFn: () => tracksControllerTrackDetail(params.TRACK_ID),
      });
      return { track };
    } catch {
      return { track: null as DetailTrackDto | null };
    }
  },
  head: ({ loaderData }) => {
    const track = loaderData?.track;
    const title = track?.title
      ? `${track.title}${track.creator?.stageName ? ` by ${track.creator.stageName}` : ""} | Lutely`
      : "Track | Lutely";
    const description =
      track?.description || "Listen to and purchase this track on Lutely.";
    const creatorSlug = track?.creator?.slug;

    return seoHead({
      title,
      description,
      type: "music.song",
      image: track?.imageUrl,
      canonicalPath: track ? `/tracks/${track.trackId}` : undefined,
      // Drafts are reachable by their owner while they are being prepared.
      noindex: !track?.publishedAt,
      jsonLd: track
        ? [
            trackJsonLd(track),
            track.title && creatorSlug && track.creator.stageName
              ? breadcrumbJsonLd([
                  {
                    name: track.creator.stageName,
                    path: creatorPath(creatorSlug),
                  },
                  { name: track.title, path: `/tracks/${track.trackId}` },
                ])
              : null,
          ]
        : null,
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <MainTrackPage type="public" />;
}
